import styled, { css } from 'styled-components'
import { colorToLunaToken } from '../../../../helpers/theming/utilities'

const activeCSS = css`
  div:nth-child(1) {
    transition-delay: 1s;
    opacity: 0;
    visibility: hidden;
  }

  div:nth-child(2) {
    transition-delay: 3s;
    opacity: 0;
    visibility: hidden;
  }

  div:last-child {
    transition-delay: none;
    opacity: 1;
    visibility: visible;
  }
`

const Anchor = styled.a`
  border: ${(props) => props.theme.size.border.width.sm} solid;
  border-color: currentColor;
  text-align: left;
  border-radius: ${(props) => props.theme.size.border.radius.base};
  margin: 15px 0;
  padding: 15px 0;
  display: flex;
  flex-direction: column;

  position: relative;
  background-color: ${(props) => props.theme.color.monochrome.white};
  align-items: center;
  overflow: hidden;
  min-height: 100%;
  width: 100%;
  text-decoration: none;
  color: ${(props) => colorToLunaToken(props.textColor, props.theme)};
  z-index: 1;
  min-height: calc(100% - 30px);
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    flex-flow: column;
    align-items: stretch;
    padding: 0;
  }
`

const ImageContainer = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
  min-width: 66%;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    flex: none;
    display: block;
    max-width: 100%;
  }

  &::before {
    content: '';
    width: 100%;
    padding-top: 100%;
    display: block;
  }
`

const Images = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    border-left: none;
  }

  ${(props) => props.active && activeCSS}
`

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-size: cover;
  transition: all 0.5s;
  background-repeat: no-repeat;

  ${(props) =>
    props.imageNumber === 1 &&
    css`
      z-index: 3;
    `}

  ${(props) =>
    props.imageNumber === 2 &&
    css`
      z-index: 2;
    `}

    ${(props) =>
    props.imageNumber === 3 &&
    css`
      z-index: 1;
    `}

    img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
    max-width: 100%;
  }
`

const Details = styled.div`
  text-align: left;
  padding: 15px;
  margin-top: 40px;
  color: ${(props) => props.theme.color.monochrome.darker};

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    padding: 0 15px;
    text-align: left;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    max-width: 100%;
  }
  @media only screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].sm}) {
    margin-top: 20px;
  }
`

const DetailSub = styled.p`
  flex-grow: 1;
  justify-content: flex-start;
  align-items: baseline;
  margin: 10px 0 0;
  color: ${(props) => props.theme.color.monochrome.darker};

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    justify-content: flex-start;
    align-items: center;
    margin: 0;
  }
`

const Bottom = styled.div`
  display: none;
  color: ${(props) => props.theme.color.monochrome.darker};

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    padding: 0 15px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
  }

  p {
    margin: 0;
  }
`

export { Anchor, ImageContainer, Images, ImageWrapper, Details, DetailSub, Bottom }
